module.exports = ".not-found {\n  height: 100vh;\n  background-color: white !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.scss
// module id = ./src/app/not-found/not-found.component.scss
// module chunks = main